import { BorderRadius, Color, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const ReceiptPanelWrapper = styled.div`
  display: flex;
  flex: 1;
  min-width: 0;
`

export const ReceiptPreviewWrapper = styled.div`
  flex: 0 0 70%;
  min-width: 0;
  height: 460px;
  border-radius: ${BorderRadius.R8};
  position: relative;
  background-color: ${Color.Grey100};
`

export const ReceiptInfoWrapper = styled.div`
  display: flex;
  flex: 0 0 30%;
  flex-direction: column;
  gap: ${Spacing.S16};
  justify-content: center;
  min-width: 0;
  margin-left: ${Spacing.S32};
`

export const TagWrapper = styled.div`
  align-self: flex-start;
`

export const OpenDocumentWrapper = styled.div`
  margin-left: -${Spacing.S16};
`
